





























import {Component, Vue} from "vue-property-decorator";
import ShortCut from "@/components/Header/ShortCut.vue";
import ShoppingCartBox from "@/components/Header/ShoppingCartBox.vue";
import SearchBox from "@/components/Header/SearchBox.vue";
import api from "@/api/api";
import getImageSource from "@/helpers/getImageSource.ts";
import selectByLang from "@/helpers/selectByLang";
import {StoreInfo} from "@/helpers/interfaces";


@Component({
  components: {
    ShortCut,
    ShoppingCartBox,
    SearchBox,
  },
})
export default class ShopHeader extends Vue {
  public storeInfo = {} as StoreInfo;
  public submenuImageSize = '60'
  public bannerSize = '1000'

  public getImageSource(size: string, path: string){
    return getImageSource(size, path)
  }

  get lang(){
    return this.$store.getters.locale
  }

  public selectByLang(optionCn, optionEn) {
    return selectByLang(optionCn, optionEn)
  }

  get page() {
    return this.$route.name;
  }

  get storeQRCodeImg(){
    return 'data:image/jpeg;base64, ' + this.storeInfo.storeQRCode
  }

  get storeId(){
    return this.$route.params.shopId
  }

  public async getStoreInfo(){
    try {
      const resp = await api.getStoreInfo(this.storeId)
      if(resp.data){
        this.storeInfo = resp.data;
      }
    } catch (e) {
      console.log(e)
    }
  }

  async created(){
    await this.getStoreInfo()
  }
}
